class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.lockedElements = [];
    this.addEventListener('click', e => {
      if (e.target.closest('#CartDrawer-Overlay')) this.close();
      if (e.target.closest('[data-cart-continue]')) this.close();
    });
    this.addEventListener('keydown', e => { if (e.key === 'Escape') {e.preventDefault(); this.close();} });
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href]');
      if (!link || this.contains(link) || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== routes.cart_url.replace(/\/$/, '')) return;
      e.preventDefault(); this.open(link); this.refresh();
    });
    this.observer = new MutationObserver(() => this.syncState());
    this.observer.observe(this, {childList:true,subtree:true});
    this.syncState();
    if (location.pathname.replace(/\/$/, '') === routes.cart_url.replace(/\/$/, '')) this.open();
    window.addEventListener('pageshow', e => {if(e.persisted) this.refresh();});
  }
  syncState() {
    const count = Number(this.querySelector('[data-cart-count]')?.textContent || 0);
    this.classList.toggle('is-empty', count === 0);
    document.querySelectorAll(`a[href="${routes.cart_url}"]`).forEach(link => {
      link.setAttribute('aria-haspopup','dialog'); link.setAttribute('aria-controls','CartDrawer');
      link.setAttribute('aria-label',`Cart, ${count} items`);
      link.querySelectorAll('.seronine-top-nav-cart-count-20260907').forEach(e => e.textContent = count);
      const label = link.querySelector('.visually-hidden'); if(label) label.textContent = `Cart [${count}]`;
      const bubble = link.querySelector('.cart-count-bubble');
      if (bubble) {bubble.hidden = !count; bubble.querySelectorAll('span').forEach(s => s.textContent = s.classList.contains('visually-hidden') ? `${count} items` : count);}
    });
    const shipping = this.querySelector('.seronine-cart-shipping');
    if (!shipping) return;
    const {total,currency,baseCurrency} = shipping.dataset;
    // Shopify publishes the presentment-to-shop conversion on every storefront load.
    const rate = currency === 'USD' ? 1 : (baseCurrency === 'USD' && window.Shopify?.currency?.active === currency ? Number(window.Shopify.currency.rate) : NaN);
    const message = shipping.querySelector('[data-shipping-message]');
    const progress = shipping.querySelector('[role="progressbar"]');
    if (!(rate > 0)) {progress.hidden = true; return;}
    const usdCents = Math.round(Number(total) / rate);
    const remaining = Math.max(0,19900 - usdCents);
    const text = remaining ? `YOU’RE $${(remaining / 100).toFixed(2)} AWAY FROM FREE SHIPPING` : "SHIPPING’S ON US";
    if(message.textContent !== text) message.textContent = text;
    progress.classList.toggle('is-complete', remaining === 0);
    const percent = Math.min(100,Math.max(0,usdCents / 199));
    progress.hidden = false; progress.setAttribute('aria-valuenow',Math.round(percent));
    progress.querySelector('span').style.width = `${percent}%`;
  }
  open(triggeredBy) {
    if(this.classList.contains('active')) return;
    clearTimeout(this.closeTimer);
    this.activeElement = triggeredBy || this.activeElement || document.activeElement;
    // Close other header layers through their existing controls before locking the page.
    document.querySelector('.seronine-search-overlay-20260905.is-open [data-seronine-search-close-20260905]')?.click();
    document.querySelector('.seronine-season-menu-20260906.is-open [data-seronine-menu-close-20260906]')?.click();
    this.inert = false;
    for (const node of document.body.children) {
      if(node === this || node.contains(this) || ['SCRIPT','STYLE','LINK'].includes(node.tagName) || node.inert) continue;
      node.inert = true; this.lockedElements.push(node);
    }
    if (!document.body.classList.contains('seronine-cart-open')) this.wasOverflowHidden = document.body.classList.contains('overflow-hidden');
    document.body.classList.add('overflow-hidden','seronine-cart-open');
    requestAnimationFrame(() => {this.classList.add('animate','active'); this.focusDialog();});
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }
  focusDialog() { if(this.classList.contains('active')) trapFocus(this.querySelector('.drawer__inner'),this.querySelector('.drawer__close')); }
  close() {
    this.classList.remove('active');
    clearTimeout(this.closeTimer);
    this.inert = true;
    this.lockedElements.forEach(node => node.inert = false); this.lockedElements = [];
    document.body.classList.remove('seronine-cart-open');
    if(!this.wasOverflowHidden) document.body.classList.remove('overflow-hidden');
    removeTrapFocus(this.activeElement?.isConnected ? this.activeElement : undefined);
  }

  async refresh() {
    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`,{credentials:'same-origin'});
      if(!response.ok) throw Error('Cart unavailable');
      this.replaceDrawer(await response.text());
    } catch { const errors = this.querySelector('#CartDrawer-CartErrors'); if(errors) errors.textContent = 'Unable to refresh your cart. Please try again.'; }
  }
  replaceDrawer(html) {
    const source = new DOMParser().parseFromString(html,'text/html').querySelector('#CartDrawer');
    if(!source) return;
    this.querySelector('#CartDrawer').innerHTML = source.innerHTML;
    this.syncState(); this.focusDialog();
  }
  renderContents(parsedState) {
    const html = parsedState.sections?.['cart-drawer'];
    if(html) this.replaceDrawer(html); else this.refresh();
    this.open();
  }
  getSectionsToRender() { return [{id:'cart-drawer',selector:'#CartDrawer'}]; }
  setActiveElement(element) {this.activeElement = element;}
}
customElements.define('cart-drawer',CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {return [{id:'CartDrawer',section:'cart-drawer',selector:'.drawer__inner'}];}
  onCartUpdate() {return this.closest('cart-drawer')?.refresh();}
  enableLoading(line) {super.enableLoading(line); const button=document.getElementById('CartDrawer-Checkout'); if(button) button.disabled=true;}
  disableLoading(line) {super.disableLoading(line); const button=document.getElementById('CartDrawer-Checkout'); if(button) button.disabled=this.closest('cart-drawer')?.classList.contains('is-empty');}
  resetQuantityInput(id) {const input=this.querySelector(`#Drawer-quantity-${id}`); if(input) input.value=input.getAttribute('value');}
  validateQuantity(event) {
    if(!event.target.matches('.quantity__input')) return;
    if(!Number.isFinite(Number(event.target.value)) || !Number.isInteger(Number(event.target.value)) || event.target.value==='') {this.resetQuantityInput(event.target.dataset.index);return;}
    if(Number(event.target.value)===0) {this.updateQuantity(event.target.dataset.index,0,event);return;}
    super.validateQuantity(event);
  }
}
customElements.define('cart-drawer-items',CartDrawerItems);

class SeronineCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.track=this.querySelector('.seronine-cart-recommendations-track');
    this.toggle=this.querySelector('[data-carousel-toggle]');
    this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.updateToggle();
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();});
    this.querySelector('[data-carousel-prev]').addEventListener('click',()=>this.move(-1));
    this.querySelector('[data-carousel-next]').addEventListener('click',()=>this.move(1));
    this.addEventListener('pointerenter',()=>this.hovered=true);
    this.addEventListener('pointerleave',()=>this.hovered=false);
    this.addEventListener('touchstart',()=>{this.pauseUntil=Date.now()+8000;},{passive:true});
    this.addEventListener('click',e=>{const button=e.target.closest('[data-recommendation-add]');if(button)this.add(button);});
    this.timer=setInterval(()=>{
      if(this.paused||this.busy||this.hovered||Date.now()<this.pauseUntil||document.hidden||this.contains(document.activeElement)||!this.closest('cart-drawer').classList.contains('active'))return;
      this.move(1);
    },2500);
  }
  move(direction) {
    const step=this.track.clientWidth+10;
    const last=this.track.scrollWidth-this.track.clientWidth;
    let next=this.track.scrollLeft+direction*step;
    if(next>last+2)next=0; if(next<0)next=last;
    this.track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  async add(button) {
    if(this.busy||button.disabled)return;
    this.busy=true;button.disabled=true;const label=button.textContent;button.textContent='…';
    const error=this.querySelector('[role="status"]');error.textContent='';
    const drawer=this.closest('cart-drawer');
    try {
      const response=await fetch(routes.cart_add_url.replace(/\.js$/, '')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:Number(button.dataset.recommendationAdd),quantity:1}],sections:['cart-drawer'],sections_url:location.pathname})});
      const data=await response.json().catch(()=>{throw Error('Unable to confirm your cart. Please close and reopen it before trying again.');});
      if(!response.ok||data.status)throw Error(data.description||'Unable to add this item. Please try again.');
      drawer.renderContents(data);
    } catch(e) {error.textContent=e.message;button.disabled=false;button.textContent=label;}
    finally {this.busy=false;}
  }
  updateToggle(){this.toggle.textContent=this.paused?'▷':'Ⅱ';this.toggle.setAttribute('aria-label',this.paused?'Play recommended products':'Pause recommended products');}
  disconnectedCallback(){clearInterval(this.timer);}
}
customElements.define('seronine-cart-recommendations',SeronineCartRecommendations);
